<template>
    
    <div>
        <section class="row loanAppFormForm">
            <div class="component-title"><h1>The reason for my loan</h1></div>

            <div class="reason-list pt-40">
                <div class="reason-item reason-item-1 pointer" for="reason-select-car">
                    <span class="ps-reason-item-msg">Vehicle <br> Expense</span>
                </div>
                <div class="reason-item reason-item-2 pointer" for="reason-select-travel">
                    <span class="ps-reason-item-msg">Travel</span>
                </div>
                <div class="reason-item reason-item-3 pointer" for="reason-select-rental">
                    <span class="ps-reason-item-msg">Home/Rent<br> Upgrades</span>
                </div>
                <div class="reason-item reason-item-4 pointer" for="reason-select-medical">
                    <span class="ps-reason-item-msg">Medical <br> Expenses</span>
                </div>
                <div class="reason-item reason-item-5 pointer" for="reason-select-education">
                    <span class="ps-reason-item-msg">Education <br>Expense</span>
                </div>
                <div class="reason-item reason-item-6 pointer" for="reason-select-purchases">
                    <span class="ps-reason-item-msg">Purchases</span>
                </div>
                <div class="reason-item reason-item-7 pointer" for="reason-select-bills">
                    <span class="ps-reason-item-msg">Bills</span>
                </div>
                <div class="reason-item reason-item-8 pointer" for="reason-select-other">
                    <span class="ps-reason-item-msg">Other</span>
                </div>
            </div>

            <div class="flx loan-container mt-60">
                  <a type="button" class="continue-btn continue-btn-small steps-btn"
                      href="#" @click.prevent="onContinue('loan-amount')">BACK</a>
                  <a type="button"
                      class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
                      href="#" @click.prevent="onContinue('introduce-yourself')">CONTINUE</a>
            </div>
        </section>
    </div>

</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>

<style>
</style>
